import React, { useState, useContext } from 'react';
import { API } from '../../API/API';
import ButtonDefault from '../../components/ButtonDefault/ButtonDefault';
import { Modal } from '@fluentui/react';
import { message } from 'antd';
import { MessageConst } from '../../const/MessageConst';
import ButtonSecondary from '../../components/ButtonSecondary/ButtonSecondary';
import { UserContext } from '../../context/UserContext';
import FieldPassword from '../../components/FieldPassword/FieldPassword';
import { MessageBar, MessageBarType, getTheme, } from '@fluentui/react';
import { IconButton } from '@fluentui/react/lib/Button';
import CryptoJS from 'crypto-js';


const PasswordChange = (props) => {

    const { userInfo } = useContext(UserContext);
    const [initData, setInitData] = useState(
        {
            "oldPassword": null,
            "newPassword": null,
            "newPasswordRepeat": null,
        }
    );
    const [data, setData] = useState({ ...initData });
    const [warning, setWarning] = useState();

    const fieldOnChanged = async (key, text, field) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            setData(tData);
        }
    }
    const encrypt = (number) => {
        var key = CryptoJS.enc.Utf8.parse('7061737323313233');
        var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
        var encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(number),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            },
        );
        return encrypted.toString();
    }

    const onSave = async () => {
        let isValid = true;
        let tempData = { ...data }
        if (tempData["newPassword"] !== tempData["newPasswordRepeat"]) {
            isValid = false;
            setWarning("Нууц үг алдаатай байна.");
        }
        else if (!tempData["newPassword"]) {
            isValid = false;
            setWarning("Нууц үг алдаатай байна.");
        }
        else if (!tempData["oldPassword"]) {
            isValid = false;
            setWarning("Нууц үг алдаатай байна.");
        }

        if (isValid) {
            let param = {
                "userID": userInfo.userid.toUpperCase(),
                "password": encrypt(tempData["oldPassword"]),
                "newPassword": encrypt(tempData["newPassword"])
            }
            await API.post('/api/shared/user-management/user/ChangePassword', param).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    localStorage.removeItem('userInfo');
                    window.location.reload();
                }
            }).catch(res => {
                setWarning(res.response.data.retmsg);
            });
        }
    }
    const theme = getTheme();

    const iconButtonStyles = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: "90%",

        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };
    const cancelIcon = { iconName: 'Cancel' };

    return (
        <Modal
            isOpen={props.isOpen}
        >
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Close popup modal"
                onClick={() => { props.onClick(); }}
            />
            <div style={{ padding: 20, width: 400 }}>
                <div>
                    <FieldPassword required onChanged={fieldOnChanged} title="Нууц үг" keyfield='oldPassword' defaultValue={data.oldPassword} />
                </div>
                <div style={{ marginTop: 20 }}>
                    <FieldPassword required onChanged={fieldOnChanged} title="Шинэ нууц үг" keyfield='newPassword' defaultValue={data.newPassword} />
                </div>
                <div style={{ marginTop: 20 }}>
                    <FieldPassword required onChanged={fieldOnChanged} title="Давтан оруулах" keyfield='newPasswordRepeat' defaultValue={data.newPasswordRepeat} />
                </div>
                {warning && (<div style={{ marginBottom: 16, marginTop: 16 }}>
                    <MessageBar
                        messageBarType={MessageBarType.warning}
                        isMultiline={false}
                        dismissButtonAriaLabel='Close'
                    >
                        {warning}
                    </MessageBar>
                </div>)}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                    <div >
                        <ButtonSecondary text='Болих' onClick={() => { props.onClick(); }} />
                    </div>
                    <div style={{ marginLeft: 16 }}>
                        <ButtonDefault text="Хадгалах" onClick={() => onSave()} />
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default PasswordChange;